import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';

export default function KaraokeDistrubutionCancelFormView1({
  isBeforePayment,
  shouldRefundOnCancellation,
  isDeliveredInJoysound,
  onNext,
} : {
  isBeforePayment: boolean,
  shouldRefundOnCancellation: boolean,
  isDeliveredInJoysound: boolean,
  onNext: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);
  const [agreement3, setAgreement3] = React.useState(false);

  return (
    <form>
      <div className="form__body">
        <dl>
          <dd>
            <CustomCheckbox
              checked={agreement1}
              setChecked={(checked) => setAgreement1(checked)}
            >
              {!isDeliveredInJoysound && '申し込み内容はすべて消去され、元に戻りません。'}
              {isDeliveredInJoysound && '配信停止後、元に戻せないことに同意します。'}
            </CustomCheckbox>
            {!isBeforePayment && (
              <CustomCheckbox
                checked={agreement2}
                setChecked={(checked) => setAgreement2(checked)}
              >
                {isDeliveredInJoysound && '印税ありオプションで配信している場合は、著作権譲渡契約を解除し、NexToneへの著作権管理委託を終了します。'}
                {!isDeliveredInJoysound && '印税ありオプションを申し込んでいる場合は、その手続きもすべて破棄します。'}
              </CustomCheckbox>
            )}
            <CustomCheckbox
              checked={agreement3}
              setChecked={(checked) => setAgreement3(checked)}
            >
              {isBeforePayment && 'Frekul残高を使用してお支払いいただいている場合は、5営業日以内に返金されます。'}
              {!isBeforePayment && shouldRefundOnCancellation && '支払い済みの料金は5営業日以内にFrekul残高に返金されます。'}
              {!isBeforePayment && !shouldRefundOnCancellation && '申し込み時の手数料等は一切返金されません。'}
            </CustomCheckbox>
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="default" disabled={!(agreement1 && (isBeforePayment || agreement2) && agreement3)} onClick={() => onNext()}>同意してキャンセル</CustomButton>
          </li>
        </ul>
      </div>
    </form>
  );
}
